export default Object.freeze({
  CREATE_WAREHOUSE: 50_010,
  EDIT_WAREHOUSE: 50_011,
  DELETE_WAREHOUSE: 50_012,
  CREATE_APPLIANCE: 50_020,
  EDIT_APPLIANCE: 50_021,
  DELETE_APPLIANCE: 50_022,
  STOP_APPLIANCE: 50_023,
  ADD_APPLIANCE_GROUP: 50_030,
  EDIT_APPLIANCE_GROUP: 50_031,
  DELETE_APPLIANCE_GROUP: 50_032,
  ADD_DEVICE: 50_040,
  REMOVE_DEVICE: 50_042,
  ADD_APPLIANCE_GROUP_ALERT: 50_050,
  EDIT_APPLIANCE_GROUP_ALERT: 50_051,
  REMOVE_APPLIANCE_GROUP_ALERT: 50_052,
  TRIGGER_APPLIANCE_GROUP_ALERT: 50_055,
  ADD_DEVICE_ALERT: 50_060,
  EDIT_DEVICE_ALERT: 50_061,
  REMOVE_DEVICE_ALERT: 50_062,
  ADD_ALERT_CONFIRMATION: 50_070,
  EDIT_ALERT_CONFIRMATION: 50_071,
  REMOVE_ALERT_CONFIRMATION: 50_072
});
